import { REPORT, REPORT_RESPONSES_TYPE_FILTER, REPORT_TAB_KEYS, UPDATE_INTEGRATIONS } from "../actions/types";

const initialState = {
  reports: {},
  error: null,
  isLoading: false,
  activeTaskId: null,
  refreshManually: false,
  passwordRequried: false,
  skipDeleteConfirmation: false,
  activeTabKey: REPORT_TAB_KEYS.OVERVIEW,
  report: { logs: [], sus: null, testDetails: {}, googleSheetIntegration: {} },
  heatmap: null,
  aiSummary: null,
  integrations: {
    showDropdown: false,
    showDrawer: false,
    showMiroDrawer: false,
    oauthStarted: false,
    synching: false,
    connectLoading: false,
    notificationData: null,
  },
  responsesTypeFilter: REPORT_RESPONSES_TYPE_FILTER.ALL,
  screenerResponsesError: null,
  screenerResponsesLoaded: false,
  screenerResponsesLoading: false,
  analysisSpaceTags: [], // Tags for Analysis Space
};

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REPORT.LOAD:
      // Add Reports in the state
      if (payload?.id) state.reports[payload.id] = payload;

      return { ...state, isLoading: true, responsesTypeFilter: REPORT_RESPONSES_TYPE_FILTER.ALL, report: payload };

    case REPORT.UPDATE:
      return { ...state, error: null, ...payload };

    case REPORT.RESET:
      return initialState;

    case REPORT.ERROR:
      return { ...state, isLoading: false, error: payload };

    case REPORT.HEATMAP_UPDATE:
      return { ...state, heatmap: payload };

    case REPORT.AI_SUMMARY_UPDATE:
      return { ...state, aiSummary: { ...state?.aiSummary, ...payload } };

    case UPDATE_INTEGRATIONS:
      const { integrations, miroIntegration, isSlackIntegrated } = payload;

      return {
        ...state,
        report: {
          ...state?.report,
          miroIntegration: {
            ...state?.report?.miroIntegration,
            ...miroIntegration,
          },
          isSlackIntegrated: isSlackIntegrated ?? state?.report?.isSlackIntegrated,
        },
        integrations: {
          ...state?.integrations,
          ...integrations,
          notificationData: integrations?.notificationData ?? null,
        },
      };

    default:
      return state;
  }
};

export default reportReducer;
